import { useQuery } from '@tanstack/react-query';

import * as fakeAPI from '_modules/chat/services/fake';
import * as httpAPI from '_modules/chat/services/http';

const api = import.meta.env.VITE_API_MODE === 'http' ? httpAPI : fakeAPI;

export const useFetchChatConfig = () =>
  useQuery({
    queryKey: ['chatConfig'],
    queryFn: async () => {
      const { data } = await api.fetchChatConfig();

      return data;
    },
    retry: false,
    staleTime: Infinity,
  });
